import flatMap from 'lodash/flatMap';

export default function splitCombinedValues(strings) {
  return (
    flatMap(strings, string => {
      const trimmedStr = string.trim();
      if (trimmedStr.includes(', ')) {
        return trimmedStr.split(', ');
      }
      if (trimmedStr.includes(',')) {
        return trimmedStr.split(',');
      }
      if (trimmedStr.includes(' ')) {
        return trimmedStr.split(' ');
      }
      return trimmedStr;
    })
      // trim the resulting elements:
      .map(str => str.trim())
      // delete all empty elements:
      .filter(str => str)
  );
}
